import { Chapter, Topic } from './../../models/chapter';
import { Course } from './../../models/course';
import { CourseService } from './../../services/course.service';
import { LocalStrorageService } from './../../services/local-strorage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Student } from 'src/app/models/student';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Variants } from './../../models/option';
import { StudentService } from '../../services/student.service';

declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.scss']
})
export class CourseComponent implements OnInit {
  student: Student;
  courseId: string;
  currentCourse: Course = new Course();
  selectedChapter: Chapter = new Chapter();
  selectedTopic: Topic = new Topic();
  chapters: Chapter[];
  selectedVideoIndex: number;
  selectedQuestionIndex: number = 0;
  showQuiz = false;
  showBuyCourseModal = true;

  ans = {
    answer: '',
    index: undefined
  };

  quiz: any;
  variants = Variants;
  allowShowNext = false;
  isCorrect = false;
  answerSelected: any;

  @ViewChild('videoContent', {static: false}) videoContent: ElementRef;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private localStorageService: LocalStrorageService,
              private studentService: StudentService,
              private courseService: CourseService) {
  }

  ngOnInit(): void {
    this.courseId = this.route.snapshot.paramMap.get('id');
    this.student = this.localStorageService.getStudent();

    if (this.student) {
      this.studentService.getStudent(this.student.phone).then((res: Student) => {
        this.student = res;
      });
    }

    this.route.paramMap.subscribe(params => {
      this.courseId = params.get('id');
      this.courseService.getCourseById(this.courseId).subscribe((res: Course) => {
        this.currentCourse = res;
        this.selectedChapter = this.currentCourse.chapters[0];
        this.topicSelected(0, 0, this.selectedChapter);
        console.log(this.currentCourse);
      });
    });
  }

  topicSelected(topicIndex: number, chapterIndex: number, chapter: Chapter) {
    const hasPermission = this.userHasPermission();
    if ((hasPermission || (topicIndex === 0 && chapterIndex === 0)) && chapter.topics[topicIndex]) {
      this.selectedChapter = chapter;
      this.selectedTopic = chapter.topics[topicIndex];
      this.setVideo(0);
      this.scrollToTop();
    } else if (!hasPermission) {
      this.router.navigateByUrl(`courses/${this.currentCourse._id}/permission`);
      // const url = `https://api.whatsapp.com/send?phone=996702000474&text= Здравствуйте, я хочу купить курс - ${this.currentCourse.title}`
    }
  }

  setVideo(i: any) {
    this.selectedVideoIndex = i;
    const rawFrame = this.selectedTopic.videos[i]?.embed;
    let frame = '';
    if (rawFrame) {
      frame = rawFrame.replace('width="400"', 'width="100%"');
    }
    this.videoContent.nativeElement.innerHTML = frame ? frame : rawFrame;
  }

  scrollToTop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, 0); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 150);
  }

  onShowQuiz() {
    this.showQuiz = true;
    this.quiz = this.selectedTopic.quiz;
  }

  onChangeAns(ans, index): void {
    this.ans.answer = ans;
    this.ans.index = index;
    this.answerSelected = true;
  }

  checkTest(): any {
    const test = this.quiz[this.selectedQuestionIndex];
    const list = document.getElementById('option-' + this.selectedQuestionIndex + this.variants[this.ans.index]);
    const element = document.getElementById('indexButtons-' + this.selectedQuestionIndex.toString());
    let answer = false;
    if (test) {
      if (test.options[this.ans.index].isCorrect) {
          this.allowShowNext = true;
          console.log(this.allowShowNext);
          answer = true;
          this.isCorrect = true;
        }
      if (this.allowShowNext) {
        list.classList.add('list-correct');
        element.classList.remove('active');
        element.classList.remove('not-correct-btn');
        element.classList.add('correct-btn');
      } else {
        list.classList.add('list-not-correct');
        element.classList.remove('active');
        element.classList.add('not-correct-btn');
      }
    }
    this.answerSelected = false;
  }

  showNextQuestion(index: number): void {
    this.selectedQuestionIndex = index;
    this.allowShowNext = false;
    this.answerSelected = false;
    this.ans.answer = '';
    this.ans.index = undefined;
    this.isCorrect = false;
  }

  private userHasPermission() {
    const courseAccess = this.student?.availableCourses.find(item => item.course._id === this.courseId);
    if (courseAccess) {
      const today = Date.parse((new Date()).toString());
      const expireDate = Date.parse(courseAccess.expireDate);
      return today <= expireDate;
    }
    return courseAccess;
  }
}
